<template>
  <div class="stripe-purchase">
    <LoadingSpinner v-if="!checkout && !errorMessage"></LoadingSpinner>
    <div v-if="errorMessage">{{errorMessage}}</div>
    <div id="checkout" class="stripe-checkout-container">
      <!-- Checkout will insert the payment form here -->
    </div>
  </div>
</template>


<script>
import axios from "axios";
import analytics from "@/analytics";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  name: "StripePurchase",
  components: {LoadingSpinner},
  props: ['product_name', 'price_id', 'return_url'],
  data() {
    return {
      stripe: null,
      checkout: null,
      errorMessage: null,
    }
  },

  async mounted() {

    return this.loadStripe()
        .then(() => {
          return this.initStripe();
        })
        .catch(err => {
          this.errorMessage = err.message;
          console.log(err);
        });
  },
  beforeUnmount() {
    if ( this.checkout ) {
      this.checkout.unmount();
      this.checkout.destroy();
    }
  },
  methods: {
    async loadStripe() {

      analytics.leaveBugsnagBreadcrumb(`loadStripe() entry`);

      if ( window.Stripe ) {
        analytics.leaveBugsnagBreadcrumb(`loadStripe() called, bug window.Stripe is already defined`);
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/basil/stripe.js';
        script.onload = (() => {
          if ( window.Stripe ) {
            analytics.leaveBugsnagBreadcrumb(`loadStripe() script loaded and 'window.Stripe' IS defined as expected`);
          } else {
            analytics.leaveBugsnagBreadcrumb(`loadStripe() script loaded but 'window.Stripe' is NOT defined as expected`);
          }
          resolve();
        });
        script.onerror = (() => {
          reject(new Error(`error loading stripe`));
        });
        document.head.appendChild(script);
      });
    },

    async initStripe() {
      analytics.leaveBugsnagBreadcrumb(`initStripe() entry`);

      return axios.get('/api/membership/stripe/stripe-publishable-key')
          .then(response => {

            analytics.leaveBugsnagBreadcrumb(`initStripe() /api/membership/stripe/stripe-publishable-key response received`,
                {
                  'window.Stripe': window.Stripe
                });

            this.stripe = window.Stripe(response.data);

            const fetchClientSecret = async () => {
              return axios.post('/api/membership/stripe/create-checkout-session', {
                price_id: this.price_id,
                return_url: this.return_url
              })
                  .then(response => {
                    return response.data.clientSecret;
                  });
            };

            return this.stripe.initEmbeddedCheckout({fetchClientSecret});
          })
          .then(checkout => {
            this.checkout = checkout;
            this.checkout.mount('#checkout');
          });
    },
  }
}
</script>


<style scoped>
.stripe-purchase {
  margin-bottom: 25px;
}
</style>